import { createZustandStore } from '../../../zustand';

import { IAssessmentsFilterState } from './types';

/**
 * Creates a global state store for the assessment filter state and also updates
 * using the respective keys.
 */
export const useAssessmentFilterStore =
  createZustandStore<IAssessmentsFilterState>()((set) => ({
    assessmentsSearchKey: '',
    updateAssessmentsSearchKey: (newKey) =>
      set(() => ({ assessmentsSearchKey: newKey })),
    assessmentsListSortFilterIndex: 0,
    updateAssessmentsListSortFilterIndex: (sortIndex: number) =>
      set(() => ({ assessmentsListSortFilterIndex: sortIndex })),
    selectedAssessmentsFilters: [],
    updateSelectedFilters: (filters) => {
      set(() => ({ selectedAssessmentsFilters: filters }));
    },
    assessmentSortFilter: 'desc',
    updateAssessmentSortFilter: (sort) =>
      set(() => ({ assessmentSortFilter: sort })),
  }));
